import {
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_XS,
  SYS_COLOR_FOREGROUND_NEUTRAL_100_LIGHT,
  SYS_COLOR_FOREGROUND_NEUTRAL_300_LIGHT,
  SYS_COLOR_SURFACE_NEUTRAL_100_LIGHT,
  SYS_COLOR_SURFACE_NEUTRAL_400_DARK,
  SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT,
  SYS_COLOR_SURFACE_NEUTRAL_800_DARK,
  GLOBAL_COLOR_ELEVATION_LEVEL1_LIGHT,
  SYS_COLOR_FOREGROUND_NEUTRAL_100_DARK,
  SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT,
  SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_ACTIVE_DARK,
  SYS_COLOR_SURFACE_NEUTRAL_100_DARK,
  SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT,
} from '@oneaudi/unified-web-common';
import {
  SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
  SYS_COLOR_SURFACE_NEUTRAL_600_DARK,
  SYS_COLOR_TEXT_COPY_DEFAULT_DARK,
  SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK,
  SYS_GRADIENT_ELEVATION_LEVEL1_FILL_DARK,
  SYS_GRADIENT_ELEVATION_LEVEL1_FILL_LIGHT,
} from '@oneaudi/unified-web-alpha-common';
import { CustomTheme } from '../@types/theme';

/* 
  Define  color tokens.
  (preferably use "only" tokens from @oneaudi/unified-web-common)
*/

export const xsBreakPoint = parseInt(SYS_BREAKPOINT_XS, 10);
export const smBreakPoint = parseInt(SYS_BREAKPOINT_SM, 10);
export const mdBreakPoint = parseInt(SYS_BREAKPOINT_MD, 10);
export const lgBreakPoint = parseInt(SYS_BREAKPOINT_LG, 10);
export const xlBreakPoint = parseInt(SYS_BREAKPOINT_XL, 10);
export const xxlBreakPoint = parseInt(SYS_BREAKPOINT_2_XL, 10);

const colorsLight = {
  mainMenu: process.env.IS_LEGACY
    ? GLOBAL_COLOR_ELEVATION_LEVEL1_LIGHT
    : SYS_GRADIENT_ELEVATION_LEVEL1_FILL_LIGHT,
  secondLevelMenu: SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT,
  headline: SYS_COLOR_FOREGROUND_NEUTRAL_100_LIGHT,
  subheadline: SYS_COLOR_FOREGROUND_NEUTRAL_300_LIGHT,
  arrowButton: SYS_COLOR_SURFACE_NEUTRAL_100_LIGHT,
  underline: SYS_COLOR_FOREGROUND_NEUTRAL_100_LIGHT,
  divider: SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT,
  stickyButtonsBg: process.env.IS_LEGACY
    ? SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT
    : SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
  currentPage: SYS_COLOR_FOREGROUND_NEUTRAL_100_LIGHT,
};

const colorsDark = {
  mainMenu: SYS_GRADIENT_ELEVATION_LEVEL1_FILL_DARK,
  secondLevelMenu: process.env.IS_LEGACY
    ? SYS_COLOR_SURFACE_NEUTRAL_800_DARK
    : SYS_COLOR_SURFACE_NEUTRAL_600_DARK,
  headline: SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK,
  subheadline: SYS_COLOR_TEXT_COPY_DEFAULT_DARK,
  underline: SYS_COLOR_FOREGROUND_NEUTRAL_100_DARK,
  divider: SYS_COLOR_SURFACE_NEUTRAL_400_DARK,
  arrowButton: SYS_COLOR_SURFACE_NEUTRAL_100_DARK,
  stickyButtonsBg: SYS_GRADIENT_ELEVATION_LEVEL1_FILL_DARK,
  currentPage: SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_ACTIVE_DARK,
};

const animations = {
  transition: '400ms cubic-bezier(0.75, 0.02, 0.5, 1)',
};

const breakpoints = {
  xs: parseInt(SYS_BREAKPOINT_XS, 10),
  sm: parseInt(SYS_BREAKPOINT_SM, 10),
  md: parseInt(SYS_BREAKPOINT_MD, 10),
  lg: parseInt(SYS_BREAKPOINT_LG, 10),
  xl: parseInt(SYS_BREAKPOINT_XL, 10),
  xxl: parseInt(SYS_BREAKPOINT_2_XL, 10),
};

export const lightTheme: CustomTheme = {
  name: 'light',
  colors: colorsLight,
  breakpoints,
  animations,
};

export const darkTheme: CustomTheme = {
  name: 'dark',
  colors: colorsDark,
  breakpoints,
  animations,
};
